// Data only: keep three.js out of the main bundle (toVec3 lives in GlobeCanvas).
export const ZONES = [
  { key: "okinawa", label: "Okinawa", lat: 26.33, lng: 127.77, color: "#0B7682", habit: "Hara hachi bu: stop eating when you are 80% full." },
  { key: "sardinia", label: "Sardinia", lat: 40.12, lng: 9.01, color: "#1F6A9E", habit: "Beans, sourdough, and a lot of community." },
  { key: "nicoya", label: "Nicoya", lat: 10.15, lng: -85.45, color: "#3E8E4E", habit: "Corn, squash and beans, with a strong plan de vida." },
  { key: "ikaria", label: "Ikaria", lat: 37.6, lng: 26.15, color: "#1E8F86", habit: "Unhurried meals, wild greens and herbal teas." },
  { key: "loma-linda", label: "Loma Linda", lat: 34.05, lng: -117.26, color: "#3A6FB0", habit: "Plant-forward plates and a weekly day of rest." },
];
export const ZONE6 = { key: "zone-6", label: "Zone 6 · Bengaluru", lat: 12.97, lng: 77.59, color: "#059669", habit: "Personalised to your biology. Unapologetically indulgent, uncompromisingly healthy." };


